import { loadable } from '@shared/core/loadableFromNamedExport';

/** Code-split entry for the Wildflowers motion type; loads only when Motion resolves on. */
export const LazyWildflowers = loadable(() => import(/* webpackChunkName: "content/guest/header/motion/wildflowers" */ './Wildflowers'), 'Wildflowers');
